// Core
import { useState } from 'react';
import { Box, Flex, Text, Divider, Grid, Image, useColorMode, useBreakpointValue } from '@chakra-ui/react';

// Assets
import placeholderVideo from 'assets/img/video-play.png';
import placeholderVideoWhite from 'assets/img/video-play-white.png';
import crystal from 'assets/img/details/crystal-3.png';


const ExclusiveSavings = ({ image }) => {
	const [isPlaying, setIsPlaying] = useState(false);
    const videoUrl = 'https://www.youtube.com/embed/X1k-mnCpVHo?autoplay=1';

    const responsiveHeight = useBreakpointValue({
        base: '194px', 
        sm: '504px' 
    });

    const videoStyle = {
    	width: '100%',
        height: responsiveHeight,
        transform: 'scale(1.01)',
    };

    const { colorMode } = useColorMode();
  	const isDark = colorMode === 'dark';
   
    return (
        <Box padding="0px" borderRadius="16px" maxW="904px" position="relative" m={{base: '32px auto 50px auto', sm: '94px auto 140px auto'}}>
            <Box position="absolute" top="0" left={{base: '-25%', sm: '0'}} w="100%" transform={{base: 'scale(0.5)', sm: 'unset' }} >
            	{ isDark && <Box bg="#099BFF" 
	            	position="absolute" 
	            	filter="blur(60px)" 
	            	h="260px" w="100px" 
	            	borderRadius="full" mt="-16px"/>}

	            <Image src={crystal} alt="crystal" position="absolute" left="-81px" bottom="-77px" transform="rotate(351deg)" width="180px" />
	            <Image src={crystal} alt="crystal" position="absolute" left="-107px" bottom="-130px" transform="rotate(331deg)" width="140px" />
	            <Image src={crystal} alt="crystal" position="absolute" left="-60px" bottom="-165px" transform="rotate(358deg)" width="100px" />
	            <Image src={crystal} alt="crystal" position="absolute" left="105px" bottom="-25px" transform="rotate(-20deg)" width="100px" />
	            <Image src={crystal} alt="crystal" position="absolute" left="8px" bottom="-54px" transform="rotate(40deg)" width="170px" zIndex="9" />
            </Box>

            <Box position="absolute" bottom="0px" right={{base: '-25%', sm: '0'}}  w="100%" transform={{base: 'scale(0.5)', sm: 'unset' }}>
            	{ isDark && <Box bg="#099BFF" 
            		right="0px"
            		bottom="-24px"
	            	position="absolute" 
	            	filter="blur(70px)" 
	            	h="260px" w="120px" 
	            	borderRadius="full"/>}

	            <Image src={crystal} alt="crystal" position="absolute" right="-100px" bottom="50px" transform="rotate(26deg)" width="150px" />
	            <Image src={crystal} alt="crystal" position="absolute" right="-110px" bottom="-40px" transform="rotate(29deg)" width="230px" zIndex="1" />
	            <Image src={crystal} alt="crystal" position="absolute" right="-17px" bottom="-60px" transform="rotate(-20deg)" width="156px" zIndex="2" />
	            
            </Box>

            <Box 
            	borderRadius="16px"
            	border="1px solid #2ABDFD"
				background="#0E1633"
            	overflow="hidden"
            	position="relative"
	            w="100%" 
	            maxH="508px"
	            h="100%"
	            aspectRatio="16/9">

            	{isPlaying ? (
	                <iframe 
					    src={videoUrl} 
					    style={videoStyle} 
					    frameBorder="0" 
					    allow="autoplay; encrypted-media" 
					    allowFullScreen
					/>
	            ) : (
	                <Image 
	                    src={ isDark ? placeholderVideo : placeholderVideoWhite} 
	                    alt="Exclusive Savings"
	                    sx={{
	                        transform: 'scale(1.02)',
	                        transformOrigin: 'center',
	                        cursor: 'pointer',
	                    }}
	                    onClick={() => setIsPlaying(true)}
	                />
	            )}

            </Box>
        </Box>
    );
};


export default ExclusiveSavings;